export const ProductAction = {
    GET_LIST: "get_list",
    UPDATE_SEARCH_TEXT: "update_search_text",
    OPEN_PRODUCT_INFO: "open_product_info",
    UPDATE_COMPANY_ID: "update_company_id",
    UPDATE_AVAILABILITY: "update_availability",
}